import { Currency } from "../../../types/global";

export const currencySyombols = {
    "EUR": "€",
    "USD": "$",
    "GBP": "£"
} as { [key in Currency]: string }